import React from 'react'
import ReactMarkdown from 'react-markdown'

import { styled } from 'redoc';

const StyledOnThisPage = styled.div`
    font-size: 14px;
    position: sticky;
    top: 100px;

    h5 {
      font-family: Montserrat,sans-serif;
      color: #27bbc5;
      font-weight: 500;
    }

    div {
        border-left: 1px solid #EDF1F2;
        margin-left: 10px;

        a, a:hover, a:visited, a:focus {
          display: block;
          padding: 10px 10px 10px 20px;
          color: #212529;
          border-radius: 4px 4px 0 0;
          text-decoration: none;
        }

        a:hover {
          background-color: #fafafa;
        }
    }

    div:last-child {
      padding-bottom: 50px;
    }
`

const OnThisPage = ({content, slugify}) => {

    const OnThisPageHeading = ({ level, children, ...props}) => {
        if (level !== 2) return null;

        const slug = slugify(children);

        return (
            <div>
                <a href={`#${slug}`}>{children}</a>
            </div>
        );
    }

  return (
        <StyledOnThisPage>
            <h5>Sur cette page</h5>
            <ReactMarkdown source={content} allowedTypes={['heading', 'text', 'emphasis', 'strong']} renderers={{heading: OnThisPageHeading}} />
        </StyledOnThisPage>
    )
}

export default OnThisPage


// WEBPACK FOOTER //
// ./src/components/OnThisPage.js